import { render, staticRenderFns } from "./ClinicalPatientGrid.vue?vue&type=template&id=6d396c78&scoped=true&"
import script from "./ClinicalPatientGrid.vue?vue&type=script&lang=js&"
export * from "./ClinicalPatientGrid.vue?vue&type=script&lang=js&"
import style0 from "./ClinicalPatientGrid.vue?vue&type=style&index=0&id=6d396c78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d396c78",
  null
  
)

export default component.exports